export default __webpack_public_path__ + "static/media/ecology-house-svgrepo-com.d10015a5.svg";